import { Skeleton } from 'tdesign-react';
import { AttachNode } from 'tdesign-react/es/common';

import botPic from '@/assets/image/preview/bot.png';
import plazaPic from '@/assets/image/preview/plaza.png';
import promotionPic from '@/assets/image/preview/promotion.png';
import spacePic from '@/assets/image/preview/space.png';
import storyPic from '@/assets/image/preview/story.png';
import PreviewDrawer from '@/components/previewDrawer';

import { BotBasePreview } from '../bot/preview';

const previewImageMap = {
  space: spacePic,
  bot: botPic,
  story: storyPic,
  promotion: promotionPic,
  plaza: plazaPic,
  props: storyPic,
};

const PreviewSkeleton: React.FC<{
  pageKey: 'space' | 'story' | 'bot' | 'promotion' | 'plaza' | 'props'
  , mode?: 'drawer' | 'inner', node?: AttachNode,
}> = ({ pageKey, ...props }) => <PreviewDrawer {...props} bgImage={previewImageMap[pageKey]}>
  <Skeleton theme="tab" loading={false}>
    {pageKey === 'bot' && <BotBasePreview />}
    {pageKey === 'promotion' && null}
    {pageKey === 'plaza' && null}
  </Skeleton>
</PreviewDrawer>;

export { PreviewSkeleton };
